import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LandTitleDto, StateDto, LgaDto, CommunityDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { Patch } from '@nestjs/common';
import { PipelineGenericFacade } from '../../states/+pipeline-generic/pipeline-generic.facade';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { loadGateway } from './../../../../../gateway/src/lib/states/+gateway/gateway.actions';
import { ImpactedAssetComponent } from '../incident/impactedasset/impactedasset.component';


@Component({
    selector: 'cradua-incidentasssetpopup',
    templateUrl: './incidentassetpopup.component.html',
    styleUrls: ['./incidentassetpopup.component.scss']
})
export class IncidentassetpopupComponent implements OnInit {


  assetForm: FormGroup;
  assetFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() asset = new EventEmitter<LandTitleDto[]>()
  @Output() deleteAssetEvent = new EventEmitter<any>()
  @Output() emitClearLandTitle = new EventEmitter<any>();
  @Input() isLoadingLandTitle: boolean;
  landTitle$: Observable<LandTitleDto[]>;
  states$: Observable<StateDto[]>;
  lgas$: Observable<LgaDto[]>;
  communitys$: Observable<CommunityDto[]>;
  isLoadingLandTitle$: Observable<any>;
  searchedLandTitle: LandTitleDto[];
  pipelineassetslink2 = [];
  impactedAsset: any[];
  filteredAssetFxn: Array<any> = [];
  selectedAssetFxnId: any;
    selectedPipelineAsset: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    AssetLinkList: any[]=[];
    task = '';
  states: any[];
  lgas: any[];
  communitys: any[];

    constructor(private fb: FormBuilder, public matdialogue: MatDialogRef<ImpactedAssetComponent>,
      public pipelineGenericFacade: PipelineGenericFacade, public gatewayFacade: GatewayFacade) {}

    ngOnInit() {
      this.gatewayFacade.loadGateway("ImpactedAsset").subscribe(asset => {
        this.impactedAsset = asset;
        console.log("value check1: ", this.impactedAsset);
      });
      console.log("value check: ", this.impactedAsset);
      // this.subsubgroups$ = this.gatewayFacade.loadGateway("SubSubGroup");
      // this.categorys$ = this.gatewayFacade.loadGateway("Category");
      // this.landTitle$ = this.pipelineGenericFacade.loadGatewayWithoutId('LandTitle');
      this.gatewayFacade.loadGateway("State").subscribe(state => {
        this.states = state;
      });
      this.gatewayFacade.loadGateway("Lga").subscribe(lga => {
        this.lgas = lga;
      });
      this.gatewayFacade.loadGateway("Communities").subscribe(community => {
        this.communitys = community;
      });
      this.createPipelineAssetForm();
    }

    protected findById = <T>(id: string) =>
    (fieldName: T) => fieldName["id"] === id;

    onSearch(query) {

      console.log("reaching search", this.searchedLandTitle, query);
    // this.landTitle$ = this.pipelineGenericFacade.loadGateway('LandTitle', query);
    this.pipelineGenericFacade.loadGateway("LandTitle", query).subscribe(a => {
      const control = this.assetFormArray.get('PipelineAssetLinks') as FormArray;
     this.clearFormArray(this.assetFormArray.get('PipelineAssetLinks') as FormArray)
      a.forEach(e =>{
        // control.insert(0, this.fb.group(e));
        control.push(this.fb.group(e));
      })

      this.pipelineassetslink2 = a
      })
    }

    onViewTask(value: LandTitleDto) {
      this.task = 'create';
      this.assetForm.patchValue(value);
    }

    onTask(value) {
      // console.log('task ', value);
      if(value === 'create') {
        this.assetForm.reset();
        this.emitClearLandTitle.emit(value);
      }
        this.task = value;
    }

    createPipelineAssetForm() {
      this.assetForm = this.fb.group({
        LandName: ['', Validators.required],
        StateId: [''],
        StateName: [''],
        LgaId: [''],
        LgaName: [''],
        CommunityId: [''],
        CommunityName: [''],
        AutoSerialId: [''],
        SubscriberId: [''],
        SubscriptionUserId: [''],
        id: null
        });
        this.assetFormArray = this.fb.group({ PipelineAssetLinks: this.fb.array([])
          });
        // this.setPipelineAsset();
    }

  // method to display pipelineassets
  setPipelineAsset() {
    // console.log('for each: ', this.searchedLandTitle);
    const control  = this.assetFormArray.controls.PipelineAssetLinks as FormArray;
    this.pipelineassetslink2.forEach( e => {
      control.push(
        this.fb.group({
          LandName: e.LandName,
          StateId: e.StateId,
          StateName: e.StateName,
          LgaId: e.LgaId,
          LgaName: e.LgaName,
          CommunityId: e.CommunityId,
          CommunityName: e.CommunityName,
          AutoSerialId: e.AutoSerialId,
          SubscriberId: e.SubscriberId,
          SubscriptionUserId: e.SubscriptionUserId,
          // id: e.id
        })
      );
    });
  }

  // method to add PipelineAsset
  addPipelineAsset(value: LandTitleDto) {
    const control  = this.assetFormArray.controls.PipelineAssetLinks as FormArray;
    control.insert(0,
          this.fb.group({
            LandName: value.LandName,
            StateId: value.StateId,
            LgaId: value.LgaId,
            CommunityId: value.CommunityId,
            id: null
          })
       );
  }

  clearFormArray = (formArray: FormArray) => {
    const control = this.assetFormArray.controls.PipelineAssetLinks as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  addNew(formValue: LandTitleDto) {
    if(this.assetForm.invalid) {
    return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.assetFormArray.get('PipelineAssets')['controls'][this.selectedIndex].patchValue({LandName: formValue.LandName, StateId: formValue.StateId, LgaId: formValue.LgaId, CommunityId: formValue.CommunityId});
    } else {
      this.addPipelineAsset(formValue);
    }
    this.selectedIndex = null;
    this.assetForm.reset()
  }

  // protected findById = <T>(id: string) =>
  // (fieldName: T) => fieldName["id"] === id;


  getStateName(id: string) {
    if(id){
      return this.states.find(this.findById<StateDto>(id)) ? this.states.find(this.findById<StateDto>(id))
      .StateName
      : null;
    }
    return null;
  }

  getLgaName(id: string) {
    if(id){
      return this.lgas.find(this.findById<LgaDto>(id)) ? this.lgas.find(this.findById<LgaDto>(id))
      .LgaName : null
    }
    return null;

  }

  getCommunityName(id: string) {
    if(id){
      return this.communitys.find(this.findById<CommunityDto>(id)) ? this.communitys.find(this.findById<CommunityDto>(id))
      .CommunityName : null
    }
    return null;

  }

  onEdit(index, value: LandTitleDto) {
    this.selectedIndex = index;
  }

  onClearForm() {
    this.selectedIndex = null;
    this.assetForm.reset();
  }

  onClose() {
    this.matdialogue.close();
  }

  checkSelected(LandName) {

    const check =  this.impactedAsset.find(a => a.LandName === LandName);
    return check ? true : false;
  }

  checkAsset(value) {

    const listdata = [];
    const data  = {
      StateName: "",
      LgaName: "",
      CommunityName: "",
      LandName: value.LandName,
      StateId: value.StateId,
      LgaId: value.LgaId,
      CommunityId: value.CommunityId,
      id: value.id,
    };
    const state = this.states.find(sub => sub.id === value.StateId);
    const lga =  this.lgas.find(cat => cat.id === value.LgaId);
    const community =  this.communitys.find(cat => cat.id === value.CommunityId);

    if(state) {
      data.StateName = state.StateName
    }
    if(lga) {
      data.LgaName = lga.LgaName
    }
    if(community) {
      data.CommunityName = community.CommunityName
    }

    listdata.push(data);
    this.AssetLinkList.unshift(listdata);
  }

  onSubmit() {
    this.matdialogue.close(this.AssetLinkList)
  }

}

